import { ReactElement } from 'react';
import MaterialImage from '../../../../components/material-image/material-image';
import handleLinkClick from '../../../../utils/handle-link-click';
import './left-aside.scss';

type LeftAsideProps = { item: Material; index: number; internalPath?: string };

const LeftAside = ({ item, index, internalPath }: LeftAsideProps): ReactElement => {
    const handleImageClick = (): void => handleLinkClick({ item, index });

    return (
        <aside className='left-aside'>
            <MaterialImage
                item={item}
                imageSize='long-mobile'
                onClick={handleImageClick}
                index={index}
                internalPath={internalPath}
            />
        </aside>
    );
};

export default LeftAside;
